import {useLingui} from '@lingui/react';
import {createTRPCReact} from '@trpc/react-query';
import type {ServerRouter} from '@zentact/api';
import {ChargebackDetailsOutput} from '@zentact/api/src/trpc/routers/chargebackRouter';
import {SlideOverWithBrandedHeader} from '../../..';
import {DisputeApiDetails} from './dispute-api-details';

type ChargebackDefensePanelProps = {
  isOpen: boolean;
  onClose: () => unknown;
  chargebackRow: ChargebackDetailsOutput | null;
  refetchChargebackList: () => void;
  trpc: ReturnType<typeof createTRPCReact<ServerRouter>>;
};

export const ChargebackDefensePanel = ({
  isOpen,
  onClose,
  chargebackRow,
  trpc,
  refetchChargebackList,
}: ChargebackDefensePanelProps) => {
  const {i18n} = useLingui();

  if (!chargebackRow) {
    return null;
  }
  const {type, pspReferenceId} = chargebackRow;

  return (
    <SlideOverWithBrandedHeader
      isOpen={isOpen}
      title={type === 'CHARGEBACK' ? i18n._('Defend Dispute') : i18n._('Supply Documents')}
      closeHandler={onClose}
    >
      <DisputeApiDetails
        trpc={trpc}
        disputePspReference={pspReferenceId}
        i18n={i18n}
        onDefenseSubmitted={() => {
          refetchChargebackList();
          onClose();
        }}
      />
    </SlideOverWithBrandedHeader>
  );
};
